import { render } from "./WordLists.vue?vue&type=template&id=6214da53&scoped=true"
import script from "./WordLists.vue?vue&type=script&lang=ts"
export * from "./WordLists.vue?vue&type=script&lang=ts"

import "./WordLists.vue?vue&type=style&index=0&id=6214da53&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6214da53"

export default script